module.exports = __webpack_public_path__ + "static/media/memberPurchase.svg";